import React from 'react';
import ChartItem from "./ChartItem";

const ChartsSide = ({data}) => {

  const colors = [
    "#FDB97C",
    "#F89170",
    "#F89370",
    "#F36162",
    "#EF495A",
    "#73B791",
    "#6BA395",
    "#618D98",
    "#58769C",
    "#4E5FA0",
    "#CF41A7",
    "#BD3BB8",
  ];
  const colorsProject = [
    "#FDB97C",
    "#F89170",
    "#F89370",
    "#F36162",
    "#EF495A",
    "#73B791",
    "#6BA395",
    "#618D98",
    "#618D98",
    "#618D98",
    "#618D98",
    "#618D98",
  ];

  return (
    <div className="chart__monitoring">
      <ChartItem
        isShow={true}
        title={"درصد موفقیت براساس سال و ماه"}
        data={data?.taskSuccessPercentByYearAndMonth}
        colors={colors}
        height={"210px"}
      />
      <ChartItem
        isShow={false}
        title={"درصد موفقیت تسک ها براساس پروژه"}
        data={data?.taskSuccessPercentByProject}
        colors={colorsProject}
        height={"190px"}
      />
      <ChartItem
        isShow={true}
        title={"میانگین تاخیر تسک ها براساس ماه و سال"}
        data={data?.taskDelayByYearAndMonth}
        colors={colors}
        height={"210px"}
      />
      <ChartItem
        isShow={false}
        title={"میانگین تاخیر تسک ها براساس پروژه"}
        data={data?.taskDelayByProject}
        colors={colorsProject}
        height={"190px"}
      />
    </div>
  );
};

export default ChartsSide;